import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import { useListContext } from "ra-core";
import { Link } from "react-router-dom";
const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "rgba(0, 0, 0, 0.08)";
  let textColor = "#000";

  return <Box sx={{ width: "100%" }}>{type}</Box>;
};

const BankListAside = ({ ...props }) => {
  const selected = props.selected;
  // let filterStatus = "";
  // if (selected == "refill") {
  //   const { filterValues } = useListContext();
  //   filterStatus = filterValues?.status;
  // }
  const totalData = props.totalData;
  const authrole = localStorage.getItem("authrole");
  const bankId = localStorage.getItem("bankId");
  return (
    <>
      <HmSubHeaderTitle
        title={"Administration"}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 0 }}>
          <MenuList component="div" id="list-campaigns-couponcode-menus">
            {authrole == "admin" && (
              <Link
                to="/banks"
                style={{
                  display: "block",
                  padding: "10px 0px 10px 10px",
                  fontWeight: "bold",
                  marginBottom: 1,
                  textDecoration: "none",
                  // color: selected === "counselors" ? "#1976d2" : "#000",
                  color: "#000",
                  background:
                    selected === "banks"
                      ? "rgba(25, 118, 210, 0.20)"
                      : "transparent",
                }}
              >
                Institution
              </Link>
            )}
            {authrole == "bankadmin" && (
              <Link
                to={`/banks/${bankId}`}
                style={{
                  display: "block",
                  padding: "10px 0px 10px 10px",
                  fontWeight: "bold",
                  marginBottom: 1,
                  textDecoration: "none",
                  // color: selected === "counselors" ? "#1976d2" : "#000",
                  color: "#000",
                  background:
                    selected === "banks"
                      ? "rgba(25, 118, 210, 0.20)"
                      : "transparent",
                }}
              >
                Institution
              </Link>
            )}
            <hr />
            {/* <CustomMenuItemLink
              to="/bankers"
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Team" count={0} />}
              selected={selected === "bankers"}
            /> */}
            <Link
              to="/bankers"
              style={{
                display: "block",
                padding: "10px 0px 10px 10px",
                fontWeight: "bold",
                marginBottom: 1,
                textDecoration: "none",
                // color: selected === "counselors" ? "#1976d2" : "#000",
                color: "#000",
                background:
                  selected === "bankers"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
              }}
            >
              Team
            </Link>
            <hr />
            {/* <CustomMenuItemLink
              to="/refill"
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Refills" count={0} />}
              selected={selected === "refill"}
            /> */}
            <Link
              to="/refill"
              style={{
                display: "block",
                padding: "10px 0px 10px 10px",
                fontWeight: "bold",
                marginBottom: 1,
                textDecoration: "none",
                // color: selected === "counselors" ? "#1976d2" : "#000",
                color: "#000",
                background:
                  selected === "refill"
                    ? "rgba(25, 118, 210, 0.20)"
                    : "transparent",
              }}
            >
              Refills
            </Link>
            {/*<Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                mt: 2,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Refills
            </Typography>
             <CustomMenuItemLink
              to='/refill?filter={"status":"refill_past180processed"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Past 180 Days Processed" count={0} />
              }
              selected={filterStatus === "refill_past180processed"}
            />
            <CustomMenuItemLink
              to='/refill?filter={"status":"refill_prepareForProcessing"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="In Process" count={0} />}
              selected={filterStatus === "refill_prepareForProcessing"}
            />
            <CustomMenuItemLink
              to='/refill?filter={"status":"refill_today"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Scheduled Today *" count={0} />}
              selected={filterStatus === "refill_today"}
            /> */}
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default BankListAside;
